/**
 * Logger - Simple logging utility for debugging
 *
 * Usage:
 * ```typescript
 * const logger = new Logger('ModuleName');
 * logger.info('Message', { data });
 * logger.error('Error occurred', error);
 * ```
 */

export class Logger {
  constructor(private prefix: string) {}

  info(message: string, data?: any): void {
    console.log(`[${this.prefix}] ${message}`, data || '');
  }

  error(message: string, error?: any): void {
    console.error(`[${this.prefix}] ${message}`, error || '');
  }

  warn(message: string, data?: any): void {
    console.warn(`[${this.prefix}] ${message}`, data || '');
  }

  debug(message: string, data?: any): void {
    console.log(`[${this.prefix}] DEBUG:`, message, data || '');
  }
}
